import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=8786e754&"
import script from "./MobileNavigation.vue?vue&type=script&lang=js&"
export * from "./MobileNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\PlentyMarkets\\49869\\20\\DiaWolfMoebel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8786e754')) {
      api.createRecord('8786e754', component.options)
    } else {
      api.reload('8786e754', component.options)
    }
    module.hot.accept("./MobileNavigation.vue?vue&type=template&id=8786e754&", function () {
      api.rerender('8786e754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/MobileNavigation.vue"
export default component.exports